/**
 * @description makes a uib-tooltip remain open (like a uib-popover) so the user can interact with it
 */
;(function () {
  angular
    .module('contrast.tooltips')
    .directive('tooltipHoverable', function ($, $timeout) {
      'ngInject'

      return {
        restrict: 'A',
        link: function (scope, ele) {
          var tooltipClass = ele.attr('tooltip-class')
          var closeOnClick = ele.attr('tooltip-hover-close-on-click')

          if (tooltipClass.indexOf(' ') > -1) {
            tooltipClass = tooltipClass.split(' ')[0]
          }

          if (closeOnClick) {
            ele.on('click', function () {
              ele.trigger('hoverableClose')
            })
          }

          ele.on('mouseover', function () {
            ele.trigger('hoverableOpen')
          })

          ele.on('mouseleave', function () {
            $timeout(function () {
              if (
                !ele.parent().find('.tooltip:hover').length &&
                !(tooltipClass && $('.' + tooltipClass + ':hover').length)
              ) {
                ele.trigger('hoverableClose')
              } else {
                if (!ele.parent().find('.tooltip:hover').length) {
                  $('.' + tooltipClass + ':hover').on(
                    'mouseleave',
                    function () {
                      ele.trigger('hoverableClose')
                    }
                  )
                } else {
                  ele
                    .parent()
                    .find('.tooltip:hover')
                    .on('mouseleave', function () {
                      ele.trigger('hoverableClose')
                    })
                }
              }
            }, 600)
          })
        }
      }
    })
})()
